export const ELLIPSIS_STR = ' ...'

export function insertBR(text: string): string {
  return text
    .trim()
    .replace(/(\r\n?|\n)\s\.{3}/g, ELLIPSIS_STR)
    .replace(/\r\n?|\n/g, '<br>')
    .replace('<br>' + ELLIPSIS_STR, ELLIPSIS_STR)
}

export function text2HTML(
  text: string,
  pClassName: string,
  appendToEnd?: string
): string {
  // 1: Plain Text Search
  let _text = insertBR(text)

  // 3: Paragraphs
  _text = _text.replace(/<br>\s*<br>/g, `</p><p class="${pClassName}">`)

  // 4: Wrap in Paragraph Tags
  _text = `<p class="${pClassName}">${_text}${
    appendToEnd ? ' ' + appendToEnd : ''
  }</p>`

  return _text
}
